module.exports = __webpack_public_path__ + "img/w4.06b3bad2.svg";